// extracted by mini-css-extract-plugin
module.exports = {"search-wrapper":"styles__search-wrapper____n4cW","search-class-input":"styles__search-class-input___2uAMQ","search-bar-open":"styles__search-bar-open___T02wL"};